var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobalErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_168732",
    "data-name": "Group 168732",
    transform: "translate(-157 -220)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83179",
    "data-name": "Path 83179",
    d: "M40,0C71.046,0,80,8.954,80,40S71.046,80,40,80,0,71.046,0,40,8.954,0,40,0Z",
    transform: "translate(157 220)",
    fill: "#1c2023"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_168731",
    "data-name": "Group 168731",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83333",
    "data-name": "Path 83333",
    d: "M30,19.5S25.875,14,19,14,8,19.5,8,19.5",
    transform: "translate(178 254)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_479",
    "data-name": "Line 479",
    y2: 10,
    transform: "translate(190 250)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_480",
    "data-name": "Line 480",
    y2: 10,
    transform: "translate(204 250)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalErrorIcon);
export default __webpack_public_path__ + "static/media/globalError_icon.2803c36c87c5b8aa28fd8fbe010fc2a2.svg";
export { ForwardRef as ReactComponent };